import * as Sentry from '@sentry/react';
import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import toaster from 'react-hot-toast';
import { createTwilioBrand } from 'api/admin/businesses/twilioIntegration';
import { CreateTwilioBrandRequestPayload } from 'types/twilio/twilioBrand';

interface useCreateTwilioBrandPayload {
  successCallback?: () => void;
}

export const useCreateTwilioBrand = ({
  successCallback,
}: useCreateTwilioBrandPayload) => {
  return useMutation<
    unknown,
    AxiosError<{ error: string }>,
    CreateTwilioBrandRequestPayload
  >({
    mutationFn: async ({ businessId, data }) => {
      return createTwilioBrand({ businessId, data });
    },
    onSuccess: async () => {
      successCallback?.();

      toaster('Brand has been created', {
        icon: '✅',
      });
    },
    onError: (error) => {
      Sentry.captureException(error);
      toaster(error?.response?.data?.error ?? 'An error occurred while creating brand', {
        icon: '❌',
      });
    },
  });
};
